import { render } from "./RealizeScreen.vue?vue&type=template&id=71e0f226"
import script from "./RealizeScreen.vue?vue&type=script&lang=js"
export * from "./RealizeScreen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Jett\\Desktop\\bg-insieme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__